'use client';

import { createContext } from 'react';
import type { AuthDrawerContextValue } from './types';

export const AuthDrawerContext = createContext<AuthDrawerContextValue | null>(null);
